import { Component, inject, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

import { NativeAuthService } from '@shared/login/native-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly nativeAuthService = inject(NativeAuthService);

  ngOnInit(): void {
    this.nativeAuthService.init();
  }
}
